"use client";

import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "../../components/ui/dialog";
import corporateImage from "../../assets/images/settings/corporate.svg";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";

const CorporateAccount = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20"
            onClick={() => {
              navigate("/settings/index");
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium"> / Corporate Account</p>
        </div>

        <div className="flex justify-center mt-16 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full bg-white rounded-2xl shadow-lg p-10 flex flex-col items-center">
            <img
              src={corporateImage}
              alt="Corporate Account"
              width={100}
              height={100}
              className="mb-6"
            />

            <h2 className="text-xl font-semibold text-gray-800 text-center mb-4">
              Let's talk business
            </h2>
            <p className="text-sm text-gray-600 text-center mb-8">
              Convert your account to corporate for enhanced business features
              and capabilities.
            </p>

            <div className="flex space-x-4">
              <Button
                variant="outline"
                className="px-6 py-2 font-semibold rounded-full"
                onClick={() => {
                  navigate("/support/faqs");
                }}
              >
                Learn more
              </Button>
              <Button
                className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-6 py-2 rounded-full font-semibold"
                onClick={() => setOpenDialog(true)}
              >
                Apply now
              </Button>
            </div>
          </div>
        </div>

        <Dialog open={openDialog} onOpenChange={setOpenDialog}>
          <DialogContent className="max-w-lg p-6 rounded-2xl">
            <DialogHeader>
              <div className="flex justify-center mb-4">
                <img
                  src={corporateImage}
                  alt="Corporate Account"
                  width={100}
                  height={100}
                  className="mb-6"
                />
              </div>
              <DialogTitle className="text-lg font-semibold text-gray-800 text-center">
                Thank you!
              </DialogTitle>
              <DialogDescription className="text-gray-600 text-center">
                Thanks for showing interest in converting your account to
                corporate. We'll be reaching out to you to discuss the details.
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center w-full pt-6">
              <DialogClose className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full ">
                Close
              </DialogClose>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default CorporateAccount;
